import { useQuery } from "@tanstack/react-query";
import { GET_PROGRAM_FOR_ATTENDANCE, getProgramForAttendance } from "..";

export const useGetProgramForAttendanceQuery = (load = false) => {
  return useQuery({
    queryKey: [GET_PROGRAM_FOR_ATTENDANCE],
    queryFn: () => getProgramForAttendance(),
    enabled: load,
  });
};
